<point-list-table
  [points]="points"
  (toggleOpenPoint)="openPoint($event)"
  (toggleSelectPoint)="selectPoint($event)"
></point-list-table>
